import { call, put } from 'typed-redux-saga'
import { takeEveryUnique } from 'Src/helpers'
import { errorHandler, headerReportApi, HeaderReportNS, headerReportSlice } from 'Modules'

function* getAll(action: HeaderReportNS.GetHeaderReport) {
	try {
		const res = yield* call(headerReportApi.getAll)
		yield* put(headerReportSlice.actions.setAll(res))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export const headerReportSaga = function* sagas() {
	yield* takeEveryUnique(headerReportSlice.actions.getAll.type, getAll)
}
